import { createContext } from "react";

const TransactionMgtContext = createContext({} as any);

export default TransactionMgtContext;